import $ from 'jquery';
import ajax from '../services/ajax';
import cookieUtil from 'js-cookie';
import config from '../config/index.js';
const siteUrl = 'http://' + config.get('currentSiteUrl');

class SignOut {
    constructor() {
        if (config.get('env') !== 'development') {
            this.url = 'http://www.fastyou.com/__/logout';
        } else {
            this.url = siteUrl + '/_/logout';
        }
        this.scopedClickListener = this.clickListener.bind(this);
        this.cookieDomain = location.hostname.replace('[^.]*', '');
    }

    clickListener() {
        this.logOut();
    }

    clearCookies() {
        const domain = this.cookieDomain;
        cookieUtil.remove('fc_auth', {domain});
        cookieUtil.remove('fastcache', {domain});
        cookieUtil.remove('fc_auth');
    }

    showLogoutSuccess() {
        this.$signOutCol.html(`
            <h1>You are now signed out.</h1>
        `);
    }

    off() {
        this.$signOutButton.off('click', this.scopedClickListener);
    }

    on() {
        this.$signOutCol = $('.js-sign-out-column');
        this.$signOutButton = $('.js-sign-out');
        this.$signOutButton.on('click', this.scopedClickListener);
    }

    logOut() {
        this.clearCookies();
        return ajax(this.url, {
            dataType: 'jsonp'
        }).then(() => {
            this.showLogoutSuccess();
        });
    }
}

export default new SignOut();

